import { FieldRequiredType } from '@ovComponents/4-module/configurableOptionFields/basicField';
import { workflowTranslation as wc } from '../../workflowTranslations';

const label = (key: string) =>
  wc(['createModelPortfolioWorkflow', 'addSecurities', key]);

/**
 * The step's options, as the component expects to be handed them.
 *
 * The hardcoded create-model-portfolio workflow writes them out in full, down
 * to a label per table column. workflow-service's schema for the same step
 * offers a title, a subtitle and two switches, so a step an admin configured in
 * the workflow builder would otherwise render a heading above an empty card:
 * every column is drawn only where its own `enabled` says so.
 *
 * The labels are the shelf workflow's, from the same translations, so both
 * spellings of the step read the same in every language.
 */
export const withSecuritiesStepDefaults = (options: any) => {
  // The columns are what the fuller shape is for, and what nothing else can
  // supply. Asking after them rather than after the keys they arrive under
  // leaves the service free to grow a switch of its own name without this
  // handing the component a table it cannot draw.
  if (options?.securityAllocationChart?.columns) return options;

  const tableShown = options?.displayAllocationsTable !== false;

  return {
    ...options,
    showSecurityAllocationTable: {
      enabled: tableShown,
      // A hidden table is not somewhere holdings can be added, so insisting on
      // them there refuses to continue over something the advisor was given no
      // way to answer.
      required: tableShown
        ? FieldRequiredType.ERROR
        : FieldRequiredType.NOT_REQUIRED,
    },
    securityAllocationChart: {
      enabled: options?.displayAllocationsPieChart !== false,
      columns: [
        {
          security: { enabled: true, label: label('columnSecurityLabel') },
          assetClass: { enabled: true, label: label('columnAssetClassLabel') },
          taxRank: { enabled: true, label: label('columnTaxRankLabel') },
          targetPercentage: {
            enabled: true,
            label: label('columnTargetPercentageLabel'),
          },
          buttonRemoveSecurity: { enabled: true },
        },
      ],
    },
  };
};
